/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_On_HintInputs */

const en_push_on_hint = /** @type {(inputs: Push_On_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications reach this device even when the app is closed; while it is open, only the bell shows them.`)
};

/**
* | output |
* | --- |
* | "Notifications reach this device even when the app is closed; while it is open, only the bell shows them." |
*
* @param {Push_On_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_on_hint = /** @type {((inputs?: Push_On_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_On_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_on_hint(inputs)
});